export const validate = {
  String(value: any, key: string = "") {
    if (typeof value !== "string" || !value.length) {
      throw Error(
        `${key} parameter must be of string type and cannot be empty.`
      )
    }
  },
  Number(value: any, key: string = "") {
    if (typeof value !== "number") {
      throw Error(
        `${key} parameter must be of string type and cannot be empty.`
      )
    }
  },
  Boolean(value: any, key: string = "") {
    if (typeof value !== "boolean") {
      throw Error(
        `The ${key} parameter must be of string type and cannot be empty.`
      )
    }
  },
  Enum(value: any, key: string = "", enumeration: string[]) {
    if (typeof value !== "string" || !value.length) {
      const _enum = enumeration?.length
        ? enumeration.join(" | ")
        : "specified enumeration type"
      throw Error(`The ${key} parameter must be the ${_enum}.`)
    }
  },
  Object(value: any, key: string = "") {
    if (typeof value !== "object") {
      throw Error(
        `${key} parameter must be of object type.`
      )
    } else {
      if (Array.isArray(value) || value === null) {
        throw Error(
          `${key} parameter must be of object type.`
        )
      }
    }
  },
  // Tuple(value: unknown, key: string = "", tuple:string[]) {
  //   tuple?.length && tuple.forEach(t =>{
  //     if(typeof value !==t){}
  //   })
  // },
}
